//import axios from 'axios';
import { AppBar } from '@mui/material';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";


const getCampaign = (pageNo=0,pageSize=10)=>{
    return axios.get(API_URL+"campaigns?pageSize="+pageSize+"&pageNo="+pageNo)
}
const getCampaignById = (campaignId=1)=>{
    return axios.get(API_URL+"campaigns/"+campaignId)
}
const updateCampaign = (campaignId,statusId)=>{
    return axios.put(API_URL+"campaigns/"+campaignId+"?status="+statusId)
}
const getCampaignResult = (campaignId=1,pageNo=0,pageSize=10)=>{
    return axios.get(API_URL+"campaigns/"+campaignId+"/results?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getCampaignResultStats = (campaignId=1)=>{
    return axios.get(API_URL+"campaigns/"+campaignId+"/result-stats")
}
const getCampaignQueue = (campaignId=1,pageNo=0,pageSize=10)=>{
    return axios.get(API_URL+"campaigns/"+campaignId+"/queue?pageNo="+pageNo+"&pageSize="+pageSize)
}

//Templates

const getAllTemplates = ()=>{
    return axios.get(API_URL+"campaign-templates")
}
const getTemplateById = (templateId)=>{
    return axios.get(API_URL+"campaign-templates/"+templateId)
}
const addUpdateTemplate = (data) =>{
    return axios.post(API_URL+"campaign-templates",data)
}
const deleteTemplate = (templateId) =>{
    return axios.delete(API_URL+"campaign-templates/"+templateId)
}
export default {
    getCampaign,
    getCampaignById,
    updateCampaign,
    getCampaignResult,
    getCampaignResultStats,
    getCampaignQueue,
    getAllTemplates,
    getTemplateById,
    addUpdateTemplate,
    deleteTemplate

}